<template>
  <div>
    <!-- bloc note -->
    <div class="container-fluid" style="height: 65px">
      <router-link to="/listes_bloc_note">
        <CButton
          style="
            margin-bottom: 7px;
            border-radius: 15px 18px;
            margin-top: -18px;
            margin-left: -8px;
          "
          color="info"
          class="mr-1 cl"
        >
          Listes Bloc Notes
        </CButton>
      </router-link>
      <form>
        <div class="row">
          <div class="col">
            <!-- <label>Nom du chauffeur</label> -->

            <div class="form-group">
              <!-- <label>Nom</label> -->
              <input
                aria-label="label"
                type="text"
                class="form-control personalise"
                placeholder="Nom et Prénom *"
                v-model="nom"
              />

              <span class="text-red" v-if="errors.nom">{{
                errors.nom[0]
              }}</span>
            </div>
          </div>
        </div>
        <!--   </b-card-text>
      </b-card> -->
        <div class="row">
          <b-card
            style="
              border: solid 1px #f5a623;
              padding: 0px;
              width: 100%;
              margin-left: 1rem !important;
              margin-right: 1rem !important;
              background-color: #ebedef !important;
            "
          >
            <CCol sm="12">
              <div class="form-group">
                <label>Date</label>

                <VueDatePicker class="form-control" v-model="selectedDate" />
              </div>
            </CCol>

            <CCol sm="12">
              <div class="form-group">
                <!--   <label  style="color:black;">Ajouter votre description ici:</label>   -->
                <textarea
                  aria-label="description"
                  v-model="description"
                  placeholder="Ajouter votre description ici ..."
                  addon-left-icon="ni ni-circle-08"
                  class="form-control"
                  id="description"
                  rows="2"
                  required
                ></textarea>
                <!--    <span class="text-red"  v-if="errors.description">{{errors.description[0]}}</span> -->
              </div>
              <hr
                style="padding: 5px; border-top: 3px solid #a12828 !important"
              />
            </CCol>
            <div class="row">
              <div class="col">
                <!-- <label>Nom du chauffeur</label> -->

                <div class="form-group">
                  <!-- <label>Nom</label> -->
                  <!--  <input
                aria-label="label"
                type="file"
                class="form-control personalise"
                placeholder="Image *"
                
              /> -->

                  <div class="form-group">
                    <label for="my-file" v-if="images.length == 10">
                      <B style="color: red">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          width="20"
                          height="20"
                          viewBox="0 0 172 172"
                          style="fill: #000000"
                        >
                          <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                          >
                            <path d="M0,172v-172h172v172z" fill="none"></path>
                            <g>
                              <path
                                d="M12.9,153.725c-4.1495,0 -7.525,-3.3755 -7.525,-7.525c0,-1.4018 0.43645,-2.80145 1.333,-4.28065l72.4765,-119.325c1.66625,-2.74555 4.15165,-4.31935 6.8155,-4.31935c2.66385,0 5.14925,1.5738 6.8155,4.3215l72.4765,119.325c0.89655,1.47705 1.333,2.8767 1.333,4.2785c0,4.1495 -3.3755,7.525 -7.525,7.525z"
                                fill="#cccccc"
                              ></path>
                              <path
                                d="M86,19.35c3.1218,0 5.0353,2.3822 5.89745,3.80335l36.23825,59.6625l36.23825,59.6625c0.7912,1.3029 1.17605,2.5198 1.17605,3.72165c0,3.5561 -2.8939,6.45 -6.45,6.45h-146.2c-3.5561,0 -6.45,-2.8939 -6.45,-6.45c0,-1.20185 0.38485,-2.41875 1.17605,-3.72165l36.23825,-59.6625l36.23825,-59.6625c0.86215,-1.42115 2.77565,-3.80335 5.89745,-3.80335M86,17.2c-3.39915,0 -6.08235,2.11345 -7.7357,4.8375c-72.4765,119.325 0,0 -72.4765,119.325c-0.8643,1.42545 -1.4878,3.0444 -1.4878,4.8375c0,4.74935 3.85065,8.6 8.6,8.6c3.76035,0 142.16015,0 146.2,0c4.74935,0 8.6,-3.85065 8.6,-8.6c0,-1.7931 -0.6235,-3.41205 -1.4878,-4.8375c-72.4765,-119.325 0,0 -72.4765,-119.325c-1.65335,-2.72405 -4.33655,-4.8375 -7.7357,-4.8375z"
                                fill="#ba9b48"
                              ></path>
                              <path
                                d="M86,120.4c-4.74965,0 -8.6,3.85035 -8.6,8.6c0,4.74965 3.85035,8.6 8.6,8.6c4.74965,0 8.6,-3.85035 8.6,-8.6c0,-4.74965 -3.85035,-8.6 -8.6,-8.6zM86,60.2c-4.74935,0 -8.6,3.55395 -8.6,7.9378c0,2.93045 4.31075,40.0115 4.3301,40.16845c0.25585,1.96725 2.0683,3.49375 4.2699,3.49375c2.2016,0 4.01405,-1.5265 4.2699,-3.49375c0.01935,-0.15695 4.3301,-37.23585 4.3301,-40.16845c0,-4.38385 -3.85065,-7.9378 -8.6,-7.9378z"
                                fill="#36404d"
                              ></path>
                            </g>
                          </g>
                        </svg>
                        Seullement 10 images peut être téléchargée!
                      </B>
                    </label>
                    <input
                      v-if="images.length < 10"
                      type="file"
                      accept="image/*"
                      multiple="multiple"
                      @change="previewMultiImage"
                      class="form-control-file"
                      id="my-file"
                    />

                    <div class="row">
                      <div
                        class="col-md-3"
                        v-for="(item, index) in preview_list"
                        :key="index"
                      >
                        <img
                          @click="Remove(item, index)"
                          class="close"
                          src="icons-panne/close-panne-tn.png"
                        /><br />

                        <img
                          alt="my image"
                          :src="item"
                          width="70%"
                          class="preview"
                        />
                        <!--   </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CButton
              @click.prevent="create"
              type="submit"
              size="sm"
              color="info"
              style="border-radius: 24px; margin-left: 22px"
              ><CIcon name="cil-check-circle" /> Ajouter
            </CButton>
          </b-card>
        </div>
      </form>
    </div>

    <!-- fin bloc note -->
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>


<script>
import Vue from "vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { apiDomain } from "../../config";
import VueInputCalculator from "vue-input-calculator";
import axios from "axios";
export default {
  components: { VueDatePicker, VueInputCalculator },
  props: {
    max: {
      type: Number,
      default: 11,
    },
    action: {
      type: String,
      default: "https://jsonplaceholder.typicode.com/posts/",
    },
  },
  name: "register",
  data() {
    return {
      description: "",
      nom: "",
      selectedDate: new Date().toISOString().split("T")[0],
      imageData: "",
      errors: {},
      /* -------------- */
      /* version 2 */
      files: [],
      preview: null,
      image: null,
      preview_list: [],
      images: [],
      /* version 2 */
      targetValue: 0,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    Remove(file, index) {
      this.preview_list.splice(index, 1);
      this.images.splice(index, 1);

      console.log("testDelete" + index);
    },
    submit(e) {
      this.isCreatingAnn = true;
      let formData = new FormData();

      formData.append("titre", this.imageDepannage);
      formData.append("description", this.description);
      formData.append("categorie", this.categorie);
      formData.append("categorie_id", this.cat_id);
      formData.append("user_id", this.client_id),
        formData.append("date_intervention", this.date_intervention);

      if (this.places.length == 0) {
        formData.append("lieux", this.lieux);
        formData.append("latitude", this.lat);
        formData.append("longitude", this.lng);
      } else if (this.places.length > 0) {
        formData.append("lieux", this.lieux.formatted_address);
        formData.append("latitude", this.center.lat);
        formData.append("longitude", this.center.lng);
      }

      for (var i = 0; i < this.images.length; i++) {
        let file = this.images[i];

        formData.append("images[" + i + "]", file);
      }
      axios
        .post(
          `${apiDomain}/api/add-annonce`,

          formData,
          {
            body: JSON.stringify(this.annonce),
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
          this.$noty.success("Annonce ajouter avec Succès ! ");
          this.isCreatingAnn = false;
          this.$router.push("/home/client/dashboard");
        })

        .catch((error) => {
          this.isCreatingAnn = false;
          //console.log(error.response.data);
          if (error.response && error.response.status == 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
    },
    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (/\.(jpe?g|png|PNG|gif)$/i.test(input.files[index].name)) {
        /*  if (input.files) { */
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          this.images.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      } else {
        if (
          confirm(
            "Veuillez choisir uniquement un fichier de type image(jpeg,png,jpg)"
          )
        ) {
          console.log("test" + this.images.length);
          this.images[this.images.length].splice([this.images.length], 1);
          this.preview_list[this.preview_list.length].splice(
            [this.preview_list.length],
            1
          );
        }
      }
    },
    /* tabs */
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    create(e) {
      let formData = new FormData();
      formData.append("date", this.selectedDate);

      formData.append("nom", this.nom);
      formData.append("titre", this.description);

      /*  for (var i = 0; i < this.images.length; i++) {
        let file = this.images[i];

        formData.append("images[" + i + "]", file);
      } */

      for (var i = 0; i < this.images.length; i++) {
        let file = this.images[i];
        formData.append("images[" + i + "][image]", file);
      }

      axios
        .post(`${apiDomain}/api/ajouter_bloc`, formData)

        .then((res) => {
          this.$noty.success("Bloc note  Ajouter avec Succès ! ");

          this.$router.push("/listes_bloc_note");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.showPart1 = true;
            this.showPart2 = false;
            this.showPart3 = false;
            this.errors = error.response.data.errors;
            this.$noty.error("OOPS ! il y a une erreur essayé de vérifier ");
          }
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
  },
};
</script>


<style>
.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: -6px;
}
img.preview {
  width: 50px;
  height: 173px;
  background-color: white;
  border: 1px solid #ddd;
}
</style>

